var infoForm = {
	bindings: {
		addMsg: '&'
	},
	/**
     * @ngInject
     */
	controller: function InfoFormCtrl($sce, flux, actions, userStore){
		var ctrl = this;
		ctrl.formData = {};
		ctrl.minDate = new Date(1980, 1, 1);
		ctrl.maxDate = new Date(new Date().getFullYear() - 10, 0, 0);
		
		function init(){
			ctrl.user = userStore.getUser();
			ctrl.formData.name = ctrl.user.name ? ctrl.user.name : '';
			ctrl.formData.birthday = ctrl.user.birthday ? new Date(ctrl.user.birthday) : new Date();
			ctrl.formData.email = ctrl.user.email ? ctrl.user.email : '';
			ctrl.formData.phone = ctrl.user.phone ? ctrl.user.phone : ''; 
		}

		function link(){
		}

		ctrl.submitForm = function submitForm(valid){
			if(valid) {
				flux.dispatch(actions.UPDATE_USER, ctrl.formData);
			} else {
				// ctrl.messages = [];
				// ctrl.addMsg({
				//     $event: {
				//         content: $sce.trustAsHtml('Ups, du mangler at udfylde nogle felter.'),
				//         type: 'receive'
				//     }
				// });
			}
		};

		ctrl.$onInit = init;
		ctrl.$postLink = link;

	},
	templateUrl: './angular/components/info-form.component.html'
};